import { render, staticRenderFns } from "./Pressing.vue?vue&type=template&id=70162f9f&scoped=true&"
import script from "./Pressing.vue?vue&type=script&lang=js&"
export * from "./Pressing.vue?vue&type=script&lang=js&"
import style0 from "./Pressing.vue?vue&type=style&index=0&id=70162f9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70162f9f",
  null
  
)

export default component.exports